import React from 'react';
import { IconProps } from '.';
import Svg from '../Svg';
const SvgIconStarSolid32 = ({ size = 32, color, ...props }: IconProps): JSX.Element => {
  return (
    <Svg width={size} height={size} fill='none' viewBox='0 0 32 32' color={color} {...props}>
      <path
        fill='currentColor'
        d='m16.5 5.5 3.38 6.848 7.557 1.098-5.468 5.33 1.29 7.528L16.5 22.75l-6.76 3.554 1.291-7.527-5.468-5.33 7.557-1.099L16.5 5.5Z'
      />
    </Svg>
  );
};
export default SvgIconStarSolid32;
